import React from 'react';
import { Switch } from 'antd';
import s from './s.module.less';

interface IProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    text?: string;
}

const SwitchWithText = ({ checked, onChange, text }: IProps) => {
    return (
        <div className={s.switchWithText}>
            <Switch checked={checked} onChange={onChange} />
            {text && <span>{text}</span>}
        </div>
    );
};

export default SwitchWithText;
